export default __webpack_public_path__ + "static/media/graduation-cap-sharp-solid.d5765240.svg";